import Countdown from "react-countdown";
import { padTo2Digits } from "../helpers/getFormattedTime";
import moment from "moment";
import DomesticFlightListItem from "../components/Domestic/DomesticFlightListItem";
import FlightListing from "../components/FlightListing";
import { useState } from "react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";
import { useDispatch, useSelector } from "react-redux";
import { revalidateItinerary } from "../actions/flightAction";
import { toast } from "@/components/ui/use-toast";

const Completionist = () => <span>Ticketing Time UP !</span>;
export default function Counter({ timeLimit, handleTimeUp, isDomestic }) {
  const { searchForm, holdedFlight: flight } = useSelector((state) => state.flights);

  const [showDialog, setShowDialog] = useState(false);
  const dispatch = useDispatch();
  const timeOutDateValue = (limitInMinutes) => {
    return moment(new Date()).add(limitInMinutes, "m").toDate();
  }
  const [timeOutDate, setTimeOutDate] = useState(timeOutDateValue(timeLimit));

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return isDomestic ? <DomesticFlightListItem /> : <FlightListing />;
    }
    else if (minutes === 2 && seconds === 0) {
      // Show a dialog to extend time
      setShowDialog(true);
      return (
        <>
          <span>
            {padTo2Digits(minutes)}:{padTo2Digits(seconds)}
          </span>
        </>
      )
    }
    else {
      // Render a countdown
      return (
        <span>
          {padTo2Digits(minutes)}:{padTo2Digits(seconds)}
        </span>
      );
    }
  };

  const handleExtendTime = () => {
    let holdFlightPayload = {
      paxTypes: [],
      departureDate: searchForm.departure,
      returnDate: searchForm.return,
      destination: searchForm.to,
      origin: searchForm.from,
      prevTranID: localStorage.transId ?? '',
      cabinClass: searchForm.cabinClass,
      tripType: flight.Direction === "OneWay" ? 1 : 2,
      supplier: flight.SupplierID,
      nationality: searchForm.nationality,
      inventoryID: flight.InventoryID.toString() ?? "",
      fareBookingKey: flight.FareOptions.BookingKey,
      fareType: searchForm.fareType
    }
    flight.FareOptions.FareBreakDowns.forEach((fbd) => {
      holdFlightPayload.paxTypes.push({
        quantity: fbd.Passenger.QTY,
        code: fbd.Passenger.Code,
        typeName: null,
      });
    });
    dispatch(
      revalidateItinerary(holdFlightPayload, (resp) => {
        if (resp.IsComplete) {
          setShowDialog(false);
          setTimeOutDate(timeOutDateValue(resp.TimeLimit))
          toast({
            variant: "success",
            title: "Time Extended",
            description: "Your ticketing time has been extended.",
          });
        }
        if (resp && !resp.IsComplete && resp.Error) {
          toast({
            variant: "error",
            title: resp.Error.ErrorType,
            description: resp.Error.Message,
          });
        }


      })
    );
  };


  return (
    <>
      <span className="inline-flex">
        {timeOutDate && (
          <Countdown
            date={timeOutDate}
            renderer={renderer}
            onComplete={handleTimeUp}
          >
            <Completionist />
          </Countdown>
        )}
      </span>
      {showDialog && <AlertDialog open={showDialog} onOpenChange={setShowDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Extend Time?</AlertDialogTitle>
            <AlertDialogDescription>
              Do you want to extend the time?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => setShowDialog(false)}
            >
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                handleExtendTime();

              }}
            >
              Extend Time
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>}
    </>

  );
}